import { Breadcrumbs, Grid, Icon } from '@mui/material';
import Button from '@mui/material/Button';
import Spin from 'components/Spin';
import React from 'react';
import { useHistory, Redirect } from 'react-router-dom';
import { useObservable } from 'react-use-observable';
import { ZAPIER_CLIENT_ID } from 'settings';
import TopPage from 'v2/components/Shared/TopPage';
import eduzzAccountsService from 'v2/services/eduzzAccount';

export default function Zapier() {
  const history = useHistory();
  const [user] = useObservable(() => eduzzAccountsService.getUser(), []);
  const [betaModules] = useObservable(() => eduzzAccountsService.getBetaModules(), []);
  if (!user || !Array.isArray(betaModules)) return null;
  if (!betaModules.includes('zapier')) return <Redirect to='/producer/dashboard' />;
  return (
    <Grid container spacing={2}>
      <Grid item xs={12}>
        <Breadcrumbs aria-label='breadcrumb'>
          <strong>Zapier</strong>
        </Breadcrumbs>
      </Grid>
      <Grid item xs={12}>
        <TopPage
          title='Minhas Integrações'
          additionalContent={
            <Button variant='contained' startIcon={<Icon>add</Icon>} onClick={() => history.push('/producer/zapier-new')}>
              Nova Integração
            </Button>
          }
        />
      </Grid>
      <Grid item xs={12}>
        <React.Suspense fallback={<Spin />}>
          <zapier-zap-manager client-id={ZAPIER_CLIENT_ID} link-target='new-tab' theme='light' />
        </React.Suspense>
      </Grid>
    </Grid>
  );
}
